import { RECAPTCHA_SITE_KEY } from "@shared/config";
import { useCallback } from "react";

export function useRecaptcha() {
  const getToken = useCallback(
    async () =>
      new Promise<string>((resolve) =>
        window.grecaptcha.ready(() =>
          window.grecaptcha
            .execute(RECAPTCHA_SITE_KEY, {
              action: "submit",
            })
            .then(resolve)
        )
      ),
    []
  );

  return { getToken };
}
